package top.wcpe.allincore.ui.runtime.element

import kotlin.jvm.JvmStatic

/**
 * 子节点遍历起点计算规则的单一权威来源。
 *
 * 渲染（UIRenderer）、命中测试（HitGeometry）与调试 overlay（OverlayRenderer）三条路径须始终使用相同
 * 基础规则以保持口径一致。**新增容器特化时仅在此处扩展**，其余调用方无需修改。
 *
 * 规则摘要：
 * - ScrollableContainer：子节点 X 加 contentOffsetX()，Y 加 contentOffsetY()。
 * - TabView：子节点 Y 加 header 高度，X 不变。
 * - 其余容器：X/Y 原样透传。
 *
 * 与 UIRenderer 的关系：UIRenderer 以本类计算结果为基础起点，在其上叠加渲染特有的逻辑
 * （ScrollableContainer 的 sticky-pin、TabView 的 pushClip 等）；这些渲染专有行为不属于本类职责。
 */
object ChildOrigin {

    /**
     * 计算容器子节点遍历起点 X。
     *
     * @param node 父容器节点
     * @param absX 父容器左上角的屏幕 X 坐标
     * @return 子节点遍历应使用的 X 起点
     */
    @JvmStatic
    fun x(node: UIElement<*>, absX: Float): Float = when (node) {
        is ScrollableContainer<*> -> absX + node.contentOffsetX()
        else -> absX
    }

    /**
     * 计算容器子节点遍历起点 Y。
     *
     * @param node 父容器节点
     * @param absY 父容器左上角的屏幕 Y 坐标
     * @return 子节点遍历应使用的 Y 起点
     */
    @JvmStatic
    fun y(node: UIElement<*>, absY: Float): Float = when (node) {
        is ScrollableContainer<*> -> absY + node.contentOffsetY()
        is TabView -> absY + node.effectiveHeaderHeight()
        else -> absY
    }
}
